import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../utils/auth";

/**
 * ProtectedRoute component that redirects unauthenticated users to login
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @param {string} props.redirectTo - URL to redirect to if not authenticated (default: "/")
 */
const ProtectedRoute = ({ children, redirectTo = "/" }) => {
  if (!isAuthenticated()) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;